import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RegularCellComponent } from '@schoolbelle/common/table';

@Component({
  selector: '[regular-cell]',
  templateUrl: './regular-cell.component.html',
  styleUrls: ['./regular-cell.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class MailmergeRegularCellComponent extends RegularCellComponent {
}
